<template>
  <a-card>
    <elwrapper label="City Start" midtext>
      <f-dropdown :items="cities" :value="city_start" hideClear @input="onCityStartChanged" />
    </elwrapper>
    <elwrapper label="City End" midtext>
      <f-dropdown :items="cities" :value="city_end" hideClear @input="onCityEndChanged" />
    </elwrapper>
    <elwrapper label="Label" midtext>
      <f-text v-model="label" />
    </elwrapper>
    <elwrapper label="Distance (km)" midtext>
      <f-number v-model="distance" />
    </elwrapper>
    <elwrapper label="Travel time" midtext>
      <f-text v-model="travel_time" />
    </elwrapper>
    <RouteViasEditor v-model="vias" :cities="cities" />
    <elwrapper label="Description" midtext>
      <f-textarea v-model="description" rows="10" />
    </elwrapper>
  </a-card>
</template>

<script>
import { RouteViasEditor, defaultRouteLabel, normalizeRouteCity } from "@/modules/routes";

export default {
  components: {
    RouteViasEditor,
  },
  data() {
    return {
      cities: [],
    };
  },
  computed: {
    city_start() {
      return this.get("city_start");
    },
    city_end() {
      return this.get("city_end");
    },
    vias: {
      get() {
        const value = this.get("vias");
        return Array.isArray(value) ? value : [];
      },
      set(newValue) {
        return this.set("vias", Array.isArray(newValue) ? newValue : []);
      },
    },
    label: {
      get() {
        return this.get("label");
      },
      set(newValue) {
        return this.set("label", newValue);
      },
    },
    distance: {
      get() {
        return this.get("distance");
      },
      set(newValue) {
        return this.set("distance", newValue);
      },
    },
    travel_time: {
      get() {
        return this.get("travel_time");
      },
      set(newValue) {
        return this.set("travel_time", newValue);
      },
    },
    description: {
      get() {
        return this.get("description");
      },
      set(newValue) {
        return this.set("description", newValue);
      },
    },
  },
  methods: {
    get(val) {
      return this.$store.getters["RouteStore/active"][val];
    },
    set(key, val) {
      return this.$store.dispatch("RouteStore/setUpdate", { key, val });
    },
    syncLabelFromCities(previousStart, previousEnd, nextStart, nextEnd) {
      const currentLabel = String(this.label || "").trim();
      const previousDefault = defaultRouteLabel(previousStart, previousEnd);
      if (!currentLabel || currentLabel === previousDefault) {
        this.set("label", defaultRouteLabel(nextStart, nextEnd));
      }
    },
    onCityStartChanged(value) {
      const next = normalizeRouteCity(value);
      const previousStart = normalizeRouteCity(this.city_start);
      const previousEnd = normalizeRouteCity(this.city_end);
      if (previousStart === next) return;
      this.set("city_start", next);
      this.syncLabelFromCities(previousStart, previousEnd, next, previousEnd);
    },
    onCityEndChanged(value) {
      const next = normalizeRouteCity(value);
      const previousStart = normalizeRouteCity(this.city_start);
      const previousEnd = normalizeRouteCity(this.city_end);
      if (previousEnd === next) return;
      this.set("city_end", next);
      this.syncLabelFromCities(previousStart, previousEnd, previousStart, next);
    },
    _queryCities() {
      return this.$store
        .dispatch("DatabaseStore/getCityList")
        .then((cities) => {
          this.cities = cities;
        })
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    this._queryCities();
  },
};
</script>
